var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m416 512h-320c-53.023 0-96-42.977-96-96v-320c0-53.023 42.977-96 96-96h320c53.023 0 96 42.977 96 96v320c0 53.023-42.977 96-96 96z",
    fill: "#a1d4e2",
    style: {},
    "data-original": "#fff9dd",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m277.65 181.63-135.5 135.49c-0.6875 0.6875-1.168 1.5352-1.4102 2.4805l-15.023 60.27c-0.44531 1.8242 0.082031 3.7461 1.4102 5.0586 1.0078 1.0078 2.3672 1.5664 3.7734 1.5664 0.43359 0 0.86719-0.046875 1.2969-0.16016l60.273-15.023c0.94141-0.24219 1.793-0.71875 2.4805-1.4102l135.49-135.49z",
    fill: "#00416d",
    style: {},
    "data-original": "#ffd200",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m364 163.15-15.09-15.09c-10.078-10.078-27.645-10.062-37.711 0l-18.48 18.48 52.801 52.801 18.48-18.48c5.0391-5.0391 7.8086-11.727 7.8086-18.863 0-7.1211-2.7695-13.809-7.8086-18.848z",
    fill: "#2a93d4",
    style: {},
    "data-original": "#ffe777",
    xmlns: "http://www.w3.org/2000/svg"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7fee5af8.svg";
export { ForwardRef as ReactComponent };